import { useNavigate, useParams } from "react-router-dom";
import { ControlList, Dialog, useListGraphqlQuery, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useCallback } from "react";
import _ from "lodash";
import { useUserStudentFamilyCreateForm } from "../hooks/useUserStudentFamilyCreateForm";
import { FAMILY_LIST_ID } from "../../../container/UserStudentFamilyListContainer";
import { useUserStudentFamilyQuery } from "../../details/hooks/useUserStudentFamilyQuery";

export const UserStudentFamilyCreateContainer = () => {
    const [
        TITLE,
    ] = useTranslations(i18n);
    const urlParams = useUrlParamsValueToString()
    const { familyId } = useParams()
    const navigate = useNavigate()
    const control = useUserStudentFamilyCreateForm(familyId ? parseInt(familyId) : undefined)
    const { invalidateQuery } = useListGraphqlQuery(FAMILY_LIST_ID);
    const { invalidateQuery: invalidateDetailsQuery } = useUserStudentFamilyQuery(familyId ? parseInt(familyId) : undefined)

    const handleSubmited = useCallback(() => {
        invalidateDetailsQuery()
        invalidateQuery()
        navigate(`..?${urlParams}`)
    }, [invalidateQuery])

    const handleClose = useCallback(() => {
        navigate(`..?${urlParams}`)
    }, [])

    return (
        <Dialog open title={TITLE} onClose={handleClose}>
            <ControlList
                {...control}
                defaultValue={{
                    id: parseInt(familyId)
                }}
                onCancel={handleClose}
                onSubmited={handleSubmited}
            />
        </Dialog>
    );
}

const i18n = [
    "Bsm.Invoice.User.Student.Family.Create.Title",
];